import { fetchCurrentUser, User } from '@library/api-user'
import { ApiKeys } from '../configs'
import useSWR from 'swr'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

type UseUserResult = {
  user: User | undefined
  error: Error | undefined
  isLoading: boolean
}

const initialState: UseUserResult = {
  user: undefined,
  error: undefined,
  isLoading: true,
}

const useUser = (): UseUserResult => {
  const { data, error } = useSWR(ApiKeys.UserCurrent, fetchCurrentUser)

  if (!data) {
    return initialState
  }

  if (error) {
    const errorMessage = `Error fetching the user in myGousto ${JSON.stringify(error)}`
    datadogLogs.logger.error(errorMessage)
    datadogRum.addError(error, {
      page: 'MyGoustoPage',
      errorMessage: errorMessage,
    })
    return { ...initialState, isLoading: false }
  }

  return { ...initialState, user: data?.user, isLoading: false }
}

export { useUser }
